import { createI18n } from 'vue-i18n';
import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';

function loadLocaleMessages () {
  var messages = {};
  messages.de = de;
  messages.en = en;
  messages.es = es;
  messages.fr = fr;
  messages.pt = pt;
  return messages;
}

export default createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  legacy: false,
  messages: loadLocaleMessages(),
});
